module.exports = __webpack_public_path__ + "static/media/29FUNOV4.685b561f.jpg";